const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://c5m5s7e269.execute-api.eu-west-1.amazonaws.com/prod',
    TARGET_API_URL: 'https://mtp7zmq4hg.execute-api.eu-west-1.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.europe.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.europe.forwoodsafety.com'
  }
};

export default config;